import React, { Component } from "react";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import Delete from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { withStyles } from "@material-ui/core/styles";
import Table from "components/Table/Table";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CardIcon from "components/Card/CardIcon.js";
import CircularProgress from "../Circular/Circular";
import Button from "components/CustomButtons/Button.js";
import NewSlot from "./NewSlot";
import NewColumn from "./NewColumn";
import EditSlot from "./EditSlot";
import ViewSlot from "./ViewSlot";
import DeleteSlot from "./DeleteSlot";
import OccupancyRate from "./OccupancyRate";
import { getSlots, deleteSlot } from "../../services/slots/slots";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import VerticalSplit from '@material-ui/icons/VerticalSplit';
import WarningIcon from '@material-ui/icons/Warning';
import Tooltip from '@material-ui/core/Tooltip';
import { createConfigFile } from "services/config";
import { api } from "services/api";

class Slots extends Component {
  constructor(props) {
    super(props);
    this.getAllSlots = this.getAllSlots.bind(this);
    this.downloadConfigFile = this.downloadConfigFile.bind(this);
    this.createConfigJson = this.createConfigJson.bind(this);
    this.createNewSlot = this.createNewSlot.bind(this);
    this.setDialog = this.setDialog.bind(this);
    this.setNotification = this.setNotification.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.loadPage = this.loadPage.bind(this);
    this.deleteSlot = this.deleteSlot.bind(this);
    this.editSlot = this.editSlot.bind(this);
    this.viewSlot = this.viewSlot.bind(this);
    this.compare = this.compare.bind(this);
    this.getLockerConfig = this.getLockerConfig.bind(this);
    this.state = {
      circular: true,
      slots: [["Nenhuma Porta encontrada!"]],
      statuses: [
        [
          {
            "status": "available",
            "pt": "Disponível"
          },
          {
            "status": "reserved",
            "pt": "Reservado"
          },
          {
            "status": "allocated",
            "pt": "Alocado pelo agente"
          },
          {
            "status": "allocatedClient",
            "pt": "Alocado pelo cliente"
          },
          {
            "status": "unavailable",
            "pt": "Bloqueadas"
          },
          {
            "status": "to_be_free",
            "pt": "Bloqueadas"
          },
          {
            "status": "dirty",
            "pt": "Disponível"
          }
        ],
        [],
      ],
      sizes: [
        {
          "size": "small",
          "pt": "Pequeno"
        },
        {
          "size": "medium",
          "pt": "Médio"
        },
        {
          "size": "large",
          "pt": "Grande"
        },
        {
          "size": "extra-large",
          "pt": "Extra Grande"
        },
      ],
      openDialog: false,
      openDialogColumn: false,
      openEdit: false,
      openView: false,
      openDelete: false,
      slot: null,
      slotData: [],
      locker: {},
      openSnackbar: false,
      success: "danger",
      message: "",
      colorHeadCart: [
        "available",
        "warning",
        "success",
        "danger",
        "warning",
        "warning",
      ],
      capacitySlots: 0,
      dirtySlots: 0,
      maintenanceSlots: 0,
      occupancyRate: false,
      dataTemp: [
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%'],
        ['01/10/2020', '3%', '13%']
      ]
    };
  }

  componentDidMount() {
    this.getAllSlots(this.props.lockerId, this.props.classes);
    this.getLockerConfig(this.props.lockerId);
  }

  getLockerConfig = (lockerId) => {
    const urlTest = `/lockers/${lockerId}`;
    api.get(urlTest).then((res) => this.setState({ locker: res.data.data }));
  };

  getAllSlots = (lockerId, classes) => {
    let { statuses, slots, sizes, capacitySlots } = this.state;
    let maintenanceSlots = 0;
    let dirtySlots = 0;

    getSlots(lockerId, (data) => {

      data = data.sort((a,b) => (a.slotName > b.slotName) ? 1 : ((b.slotName > a.slotName) ? -1 : 0))

      this.setState({ slotData: data });


      capacitySlots = (data.length) ? data.length - 1 : 0;
      slots = (data.length > 0) ? [] : slots;
      data.forEach(slot => {

        let { slotName, status, size, label } = slot;

        size = size ? size : "medium";

        let ptStatus = statuses[0].filter(st => st.status === status)[0].pt;

        if (status === 'dirty') {
          dirtySlots += 1;
          ptStatus = (<div style={{ display: 'flex' }}><p>{ptStatus}</p><WarningIcon style={{ color: '#00acc1', margin: '0.6rem 0.2rem' }} /></div>);
        } else if (status === 'to_be_free') {
          maintenanceSlots += 1;
          ptStatus = (<div style={{ display: 'flex' }}><p>{ptStatus}</p><WarningIcon style={{ color: '#fdd90c', margin: '0.6rem 0.4rem' }} /></div>);
        }

        let ptSize = sizes.filter(s => s.size === size)[0].pt;

        slots.push([slotName, label, ptSize, ptStatus,
          <div><IconButton aria-label="view">
            <Tooltip title="Editar porta">
              <Edit className={classes.iconView} onClick={() => this.editSlot(slot)} />
            </Tooltip>
          </IconButton>
            <IconButton aria-label="view">
              <Tooltip title="Excluir porta">
                <Delete className={classes.iconView} onClick={() => this.deleteSlot(slot)} />
              </Tooltip>
            </IconButton>
            <IconButton aria-label="view">
              <Tooltip title="Visualizar últimas encomendas">
                <Visibility className={classes.iconView} onClick={() => this.viewSlot(slot)} />
              </Tooltip>
            </IconButton></div>]);
      });

      statuses[0].forEach(st => {
        let count = data.filter(sl => sl.status === st.status).length;

        let statusString = '';

        switch (st.status) {
          case 'available':
            statusString = st.pt
            break;
          case 'reserved':
            statusString = st.pt
            break;
          case 'allocated':
          case 'allocatedClient':
            statusString = st.pt
            break;
          case 'unavailable':
          case 'to_be_free':
          case 'dirty':
            statusString = st.pt
            break;
          default:
            statusString = st.pt
            break;
        }

        if (statuses[1].filter(s => s.includes(st.pt))[0]) {
          let i = statuses[1].findIndex(x => x.includes(st.pt));
          let newValue = Number(statuses[1][i].split(':')[1]) + count;
          statuses[1][i] = `${statusString}:${newValue}`
        } else {
          statuses[1].push(` ${statusString}:${count} `);
        }
      });

      this.setState({ slots, statuses, capacitySlots, maintenanceSlots, dirtySlots, circular: false, });
    })
  };

  compare(a, b) {
    if (parseInt(a.slotName) > parseInt(b.slotName)) {
      return 1;
    }
    return -1;
  }

  setDialog(openDialog) {
    this.setState({ openDialog, openEdit: openDialog, openView: openDialog, openDelete: openDialog, openDialogColumn: openDialog});
  }

  handleClose() {
    this.setState({ openSnackbar: false });
  }

  setNotification(message, success) {
    if (success === "success") {
      this.setState(
        {
          circular: true,
          message,
          success,
          openSnackbar: true,
          statuses: [
            [
              {
                "status": "available",
                "pt": "Disponível"
              },
              {
                "status": "reserved",
                "pt": "Reservado"
              },
              {
                "status": "allocated",
                "pt": "Alocado pelo agente"
              },
              {
                "status": "allocatedClient",
                "pt": "Alocado pelo cliente"
              },
              {
                "status": "unavailable",
                "pt": "Bloqueadas"
              },
              {
                "status": "to_be_free",
                "pt": "Bloqueadas"
              },
              {
                "status": "dirty",
                "pt": "Disponível"
              }
            ],
            [],
          ],
          sizes: [
            {
              "size": "small",
              "pt": "Pequeno"
            },
            {
              "size": "medium",
              "pt": "Médio"
            },
            {
              "size": "large",
              "pt": "Grande"
            },
            {
              "size": "extra-large",
              "pt": "Extra Grande"
            },
          ]
        },
        () => this.loadPage()
      );
    } else {
      this.setState({ message, success, openSnackbar: true });
      setTimeout(() => {
        this.handleClose();
      }, 6000);
    }
  }


  createConfigJson = (data) => {

    const dataModel = createConfigFile(this.state.locker, data);
    const json = JSON.stringify(dataModel, null, 2);
    // console.log(JSON.stringify(dataModel))

    return json;
  }



  downloadConfigFile = () => {
    const element = document.createElement("a");
    const file = new Blob([this.createConfigJson(this.state.slotData)], {type: 'application/json'});
    element.href = URL.createObjectURL(file);
    element.download = "config.json";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  }

  render() {
    const { classes } = this.props;
    const { circular, occupancyRate, dataTemp, capacitySlots } = this.state;
    let layout;

    layout = (circular) ?
      <div className={classes.root}>
        <CircularProgress />
      </div>
      : (occupancyRate) ?
        <OccupancyRate lockerId={this.props.lockerId} capacity={capacitySlots} />
        : <div>
          <div>

            <Button style={{marginRight: 10}} color="primary" onClick={() => this.createNewSlot()} >Criar Porta</Button>

            <Button style={{marginRight: 10}} color="primary" onClick={() => this.createNewColumn()} >Criar Coluna</Button>

            <Button style={{marginRight: 10}} color="primary" onClick={() => this.openOccupancyRate()} >Taxa de Ocupação</Button>

            <Button color="primary" onClick={() => this.downloadConfigFile()} >Exportar Mapa</Button>

          </div>
          <GridContainer>
            <GridItem xs={12} sm={6} md={2}>
              <Card className="locker-background">
                <CardHeader className="locker-align-text" color="available" stats icon>
                  <CardIcon className="locker-slots" color="available">
                    <Tooltip title="Compartimentos disponíveis para depósito de encomenda">
                      <VerticalSplit />
                    </Tooltip>
                  </CardIcon>
                  <h3 className={classes.cardTitle}>
                    {Number(this.state.statuses[1][0].split(':')[1])}
                  </h3>
                </CardHeader>

                <h5 className={classes.cardTitle}><p className="locker-padding">Disponíveis</p></h5>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={2}>
              <Card className="locker-background">
                <CardHeader className="locker-align-text" color="warning" stats icon>
                  <CardIcon className="locker-yellow locker-slots" color="warning">
                    <Tooltip title="Compartimentos reservados que serão alocados pelo agente de Correios">
                      <VerticalSplit />
                    </Tooltip>
                  </CardIcon>
                  <h3 className={classes.cardTitle}>
                    {Number(this.state.statuses[1][1].split(':')[1])}
                  </h3>
                </CardHeader>
                <h5 className={classes.cardTitle}><p className="locker-padding">Reservadas</p></h5>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={2}>
              <Card className="locker-background">
                <CardHeader className="locker-align-text" color="success" stats icon>
                  <CardIcon className="locker-slots" color="success">
                    <Tooltip title="Compartimentos com encomenda depositada pelo agente de Correios">
                      <VerticalSplit />
                    </Tooltip>
                  </CardIcon>
                  <h3 className={classes.cardTitle}>
                    {Number(this.state.statuses[1][2].split(':')[1])}
                  </h3>
                </CardHeader>
                <h5 className={classes.cardTitle}><p className="locker-padding">Alocado pelo agente</p></h5>
              </Card>
            </GridItem>
            {/* <GridItem xs={12} sm={6} md={2}>
              <Card className="locker-background">
                <CardHeader className="locker-align-text" color="warning" stats icon>
                  <CardIcon className="locker-slots" color="info">
                    <Tooltip title="Compartimentos com encomenda depositada pelo cliente">
                      <VerticalSplit />
                    </Tooltip>
                  </CardIcon>
                  <h3 className={classes.cardTitle}>
                    {Number(this.state.statuses[1][3].split(':')[1])}
                  </h3>
                </CardHeader>
                <h5 className={classes.cardTitle}><p className="locker-padding">Alocado pelo cliente</p></h5>
              </Card>
            </GridItem> */}
            <GridItem xs={12} sm={6} md={2}>
              <Card className="locker-background">
                <CardHeader className="locker-align-text" color="danger" stats icon>
                  <CardIcon className="locker-slots" color="danger">
                    <Tooltip title="Compartimentos bloqueados para alocação">
                      <VerticalSplit />
                    </Tooltip>
                  </CardIcon>
                  <h3 className={classes.cardTitle}>
                    {Number(this.state.statuses[1][4].split(':')[1])}
                  </h3>
                </CardHeader>
                <h5 className={classes.cardTitle}><p className="locker-padding">Bloqueadas</p></h5>
              </Card>
            </GridItem>

            <GridItem xs={12} sm={6} md={2}>
              <Card className="locker-background">
                <CardHeader className="locker-align-text" color="danger" stats icon>
                  <CardIcon className="locker-black" color="danger">
                    <Tooltip title="Quantidade total de compartimentos">
                      <VerticalSplit />
                    </Tooltip>
                  </CardIcon>
                  <h3 className={classes.cardTitle}>
                    {Number(this.state.capacitySlots)}
                  </h3>
                </CardHeader>
                <h5 className={classes.cardTitle}><p className="locker-padding">Total</p></h5>
              </Card>
            </GridItem>
{/* 

            <GridItem xs={12} sm={6} md={2}>
              <div className="extra-cards">
                <Card className="locker-background locker-extra-cards">
                  <CardHeader className="locker-align-text-left" color="success" icon>
                    <CardIcon className="locker-black" color="warning">
                      <Tooltip title="Quantidade total de compartimentos">
                        <VerticalSplit />
                      </Tooltip>
                    </CardIcon>
                    <p className="locker-black-title">
                      {this.state.capacitySlots} Total
                  </p>
                  </CardHeader>
                </Card> */}
                {/* <Card className="locker-background locker-extra-cards locker-extra-cards-s"> */}
                  {/* <Tooltip title="Solicitações de limpeza e manutenção provenientes do locker ou do software de gestão"> */}
                    {/* <div className="locker-black-title-s"> */}
                      {/* Solicitações: */}
                    {/* </div> */}
                  {/* </Tooltip> */}
                  {/* <div className='locker-align-icons-text'><WarningIcon style={{ color: '#00acc1' }} /><div>{this.state.dirtySlots} Limpeza</div></div> */}
                  {/* <div className='locker-align-icons-text'><WarningIcon style={{ color: '#fdd90c' }} /><div>{this.state.maintenanceSlots} Manutenção</div></div> */}
                {/* </Card> */}
              {/* </div> */}
            {/* </GridItem> */}
          </GridContainer>
          <Table
            tableHeaderColor="primary"
            tableHead={["Porta", "Label", "Tamanho", "Status", "Ações"]}
            tableData={this.state.slots}

          />
        </div>

    return (
      <div>
        {layout}
        {(this.state.openDialog) ? <NewSlot
          lockerId={this.props.lockerId}
          open={this.state.openDialog}
          setNotification={this.setNotification}
          onChange={this.setDialog}
        /> : null}
        {(this.state.openDialogColumn) ? <NewColumn
          lockerId={this.props.lockerId}
          open={this.state.openDialogColumn}
          setNotification={this.setNotification}
          onChange={this.setDialog}
        /> : null}
        {(this.state.openEdit) ? <EditSlot
          lockerId={this.props.lockerId}
          slot={this.state.slot}
          open={this.state.openEdit}
          setNotification={this.setNotification}
          onChange={this.setDialog}
        /> : null}
        {(this.state.openView) ? <ViewSlot
          lockerId={this.props.lockerId}
          slot={this.state.slot}
          open={this.state.openView}
          setNotification={this.setNotification}
          onChange={this.setDialog}
        /> : null}
        {(this.state.openDelete) ? <DeleteSlot
          lockerId={this.props.lockerId}
          slot={this.state.slot}
          open={this.state.openDelete}
          setNotification={this.setNotification}
          onChange={this.setDialog}
        /> : null}
        <Snackbar
          place="tc"
          color={this.state.success}
          icon={AddAlert}
          message={this.state.message}
          open={this.state.openSnackbar}
          closeNotification={this.handleClose}
          close
        />
      </div>
    );
  }
  loadPage() {
    setTimeout(() => {
      this.componentDidMount();
    }, 500);

    setTimeout(() => {
      this.handleClose();
    }, 6000);
  }

  createNewSlot() {
    this.setState({ openDialog: true });
  }

  createNewColumn() {
    this.setState({ openDialogColumn: true });
  }

  openOccupancyRate() {
    this.setState({ occupancyRate: true });
  }

  editSlot(slot) {
    this.setState({ slot, openEdit: true });
  }

  viewSlot(slot) {
    this.setState({ slot, openView: true });
  }

  deleteSlot(slot) {
    this.setState({ slot, openDelete: true });
  }

}
export default withStyles(styles)(Slots);
